import { render, staticRenderFns } from "./CategoryStatisticalReport.vue?vue&type=template&id=4f9a7ea2&scoped=true&"
import script from "./CategoryStatisticalReport.vue?vue&type=script&lang=js&"
export * from "./CategoryStatisticalReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9a7ea2",
  null
  
)

export default component.exports